module.exports = __webpack_public_path__ + "static/media/hero-l.db0105e4.jpg";